import { Redirect } from 'react-router-dom';
import { ROUTES } from 'routing';
import { useUser } from 'shared/hooks';
import { UploadPDFPage } from './upload-pdf-page';

export function UploadPDFPageResolver() {
  const user = useUser();

  if (!user) {
    return null;
  }

  const isInsightEmployee = user?.isInsightEmployee;

  if (!isInsightEmployee) {
    return <Redirect to={ROUTES.products} />;
  }

  return <UploadPDFPage user={user} />;
}
